import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";

export class LevelsService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/levels`;
    const data =  await super.getRequest<Model[]>(url, opts);
    return data.filter(x => !x.isNotApplicable).map(x => ({ ...x, levelId: x.id}))
  }
  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/levels/${id}`;
    return await super.getRequest<Model>(url, opts);
  }
}
